module.exports = __webpack_public_path__ + "assets/img/image(3).aa57ed13.png";